<template>
  <v-container>
    <v-layout row>
      <v-flex xs6>
        <v-layout
          row
          align-center
        >
          <v-flex>
            <v-avatar
              size="75px"
              tile>
              <img
                src="@/assets/logo.png"
                alt="Baxter State Park"
              >
            </v-avatar>
          </v-flex>
          <v-flex>
            <h1>Baxter State Park Parking Pass</h1>
          </v-flex>
        </v-layout>
        <h2 class="mt-4">PLEASE PRINT THIS PARKING RESERVATION.</h2>
        <p>
          <span v-html="settings.textParkingReservationText"/>
        </p>
        <v-divider class="my-4"/>
        <v-layout row>
          <v-flex xs4>
            <h3>Parking Information</h3>
            <p>
              Area: {{ parkingBooking.parkingName }}<br>
              Date: {{ parkingBooking.reservedDate }}<br>
            </p>
            <h3>Visitor Information</h3>
            <p>
              Last Name: {{ person.lastName }}<br>
              Number in Party: ________<br>
              <span v-if="parkingBooking.commercialPermitID">CUPS #: {{ parkingBooking.commercialPermitID }} </span>
            </p>
            <h3>Vehicle Information</h3>
            <p>
              State: {{ parkingBooking.vehicleState }}<br>
              Plate Number: {{ parkingBooking.vehicleLicensePlate }}<br>
              Permit Number: {{ parkingBooking.parkingBookingID }}<br>
              Gate Passes: {{ parkingBooking.gatePasses }}<br>
            </p>
          </v-flex>
          <v-layout
            column
            align-center
            justify-center
          >
            <VueQrcode
              :value="qrData"
              :options="{ size: 300 }"
            />
          </v-layout>
        </v-layout>
        <v-divider class="my-4"/>
        <p>
          Please note that reserved day use parking spaces will be held until
          7:05am the day of the reservations. If you have not arrived at the
          gatehouse by 7:05am, the reservation will be cancelled and the space
          will be released for use by other visitors.
        </p>
      </v-flex>
      <v-flex xs6>
        <img
          src="@/assets/speedLimit.png"
          alt="Baxter State Park"
        >
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueQrcode from '@xkeshi/vue-qrcode'
export default {
  components: {
    VueQrcode
  },
  computed: {
    ...mapGetters({
      parkingBooking: 'parkingBookings/parkingBooking',
      person: 'person/person'
    }),
    qrData () {
      return JSON.stringify({
        type: 'parking',
        ID: this.$route.params.id,
        personID: this.person.personID
      })
    }
  },
  created () {
    let parkingBooking = {
      parkingBookingID: this.$route.params.id
    }
    this.getParkingBooking(parkingBooking)
  },
  methods: {
    ...mapActions({
      getParkingBooking: 'parkingBookings/getParkingBooking'
    })
  }
}
</script>
